import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import PortalCard from "./components/PortalCard";
import "./index.css";
let sample_domain = [
  { name: "Concierge", active: false, url: "https://aiconcierge.io" },
  { name: "User verification", active: false, url: "https://profiletest.io" },
  {
    name: "Travel Tool",
    active: false,
    url: "https://booking.thetravelrobot.com",
  },
  {
    name: "Shop Tool",
    active: false,
    url: "https://cloudmarketplace.io",
  },
  { name: "Community Tool", active: false, url: "https://cloudcommunities.io" },
  { name: "Property reference", active: false, url: "https://rentrobot.io" },
  {
    name: "Property Manager",
    active: false,
    url: "https://properties.ecosystem.co.uk",
  },
  {
    name: "Property Tasks",
    active: false,
    url: "https://taskers.ecosystem.co.uk",
  },
];
class PropertyPortals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: false,
      agencies: [],
      brand_name: "",
      brand_url: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        const { domain } = res;
        if (!domain) this.setState({ domain: sample_domain });
        else this.setState({ domain });
        console.log("brand_data", res);
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });
    }
  }
  activePortal = (index) => {
    console.log("active portal", index);
    let { domain, brand } = this.state;
    domain[index].active = true;
    console.log("domain", domain);
    Firebase.updateBrandDataById(brand, { domain: domain });
  };
  showPortals = () => {
    const { domain, brand_name } = this.state;
    return domain.map((item, index) => {
      if (index > 4)
        return (
          <PortalCard
            index={index}
            portal={item}
            brand={brand_name}
            activePortal={() => this.activePortal(index)}
          />
        );
    });
  };
  render() {
    const {
      username,
      role,
      logo,
      domain,
      brand,
      brand_name,
      is_property_brand,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="content">{this.showPortals()}</div>
          <div className="content">
            <div className="usercard-content"></div>
            <div className="usercard-content">
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                Property Manager Access
              </div>
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                <b>User:</b>{" "}
                {`${brand_name
                  .trim()
                  .replace(/ /g, "_")}@ecosystem.life`.toLowerCase()}
              </div>
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                <b>PW:</b> Ecosystem2020
              </div>
            </div>
            <div className="usercard-content">
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                Property Tasker Access
              </div>
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                <b>User:</b>{" "}
                {`${brand_name
                  .trim()
                  .replace(/ /g, "_")}_tasker@ecosystem.life`.toLowerCase()}
              </div>
              <div
                className="block text-center"
                style={{ flexDirection: "row", margin: "10px 0" }}
              >
                <b>PW:</b> Ecosystem2020
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
export default PropertyPortals;



// WEBPACK FOOTER //
// ./src/screens/PropertyPortals/index.js